module.exports = __webpack_public_path__ + "img/telegraph.2fcbfab.jpg";